import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/**
 * @file 下拉类型筛选组件
 * @author alfielv
 */
import _ from 'lodash';
import React, { useCallback } from 'react';
import FilterSelection from './FilterSelection';
import FilterPopover from './FilterPopover';
export default /*#__PURE__*/React.memo(function (props) {
  var type = props.type,
      name = props.name,
      value = props.value,
      title = props.title,
      clearKeys = props.clearKeys,
      config = props.config,
      nameConfig = props.nameConfig,
      customComponentRef = props.customComponentRef,
      clearable = props.clearable,
      onFilterDataUpdate = props.onFilterDataUpdate,
      defaultContent = props.defaultContent; // 清空选项

  var deleteItems = useCallback(function () {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _.map(keys, function (key) {
      onFilterDataUpdate === null || onFilterDataUpdate === void 0 ? void 0 : onFilterDataUpdate({
        type: 'DELETE',
        key: key
      });
    });
  }, [onFilterDataUpdate]); // 选择下拉项

  var handleChange = useCallback(function (value) {
    // 联动清空数据
    onFilterDataUpdate === null || onFilterDataUpdate === void 0 ? void 0 : onFilterDataUpdate({
      type: 'UPDATE_AND_DELETE',
      key: name,
      value: value,
      deleteKeys: clearKeys
    });
  }, [name, clearKeys, onFilterDataUpdate]); // 选择字段名下拉项

  var handleNameChange = useCallback(function (value) {
    // 联动清空数据
    onFilterDataUpdate === null || onFilterDataUpdate === void 0 ? void 0 : onFilterDataUpdate({
      type: 'UPDATE_AND_DELETE',
      key: value,
      value: '',
      deleteKeys: [name]
    });
  }, [name, onFilterDataUpdate]); // 清空筛选项

  var handleClear = useCallback(function () {
    var keys = [name].concat(_toConsumableArray(clearKeys || []));
    deleteItems(keys);
  }, [name, clearKeys, deleteItems]);

  if (type === 'select-tree' || type === 'select' || type === 'date-picker') {
    return /*#__PURE__*/React.createElement(FilterSelection, {
      type: type,
      name: name,
      title: title,
      config: config,
      nameConfig: nameConfig,
      value: value,
      clearable: clearable,
      onChange: handleChange,
      onNameChange: handleNameChange,
      onClear: handleClear
    });
  }

  return /*#__PURE__*/React.createElement(FilterPopover, {
    type: type,
    customComponentRef: customComponentRef,
    name: name,
    title: title,
    config: config,
    value: value,
    clearable: clearable,
    defaultContent: defaultContent,
    onChange: handleChange,
    onClear: handleClear
  });
});